import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FiGift,
  FiTag,
  FiZap,
  FiShare2,
  FiMail,
  FiCopy,
  FiX,
  FiClock,
  FiArrowRight,
  FiClipboard,
  FiSearch,
  FiCheck,
  FiShield,
  FiPercent,
} from "react-icons/fi";
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import { toast } from "react-toastify";
import "../index.css";
import "./EmployeeDashboard.css";
import "./EmployeeLeaves.css";

const OFFERS_DATA = [
  {
    id: 1,
    title: "Summer Sale Blast!",
    description: "Get 50% off on all premium hiring plans. Limited time offer!",
    code: "SUMMER50",
    discount: "50% OFF",
    validTill: "2026-12-31",
    tag: "HOT",
    tagColor: "rose",
    coins: 500,
    minPurchase: "₹1,000",
    category: "Seasonal",
  },
  {
    id: 2,
    title: "Referral Bonus Deal",
    description: "Earn 100 bonus coins for every friend who registers using your referral link.",
    code: "REFER100",
    discount: "100 Coins",
    validTill: "2026-12-31",
    tag: "BONUS",
    tagColor: "emerald",
    coins: 100,
    minPurchase: "Free",
    category: "Referral",
  },
  {
    id: 3,
    title: "Premium Plan Upgrade",
    description: "Upgrade your recruitment tier and receive a 30% discount + 500 bonus coins.",
    code: "PREMIUM30",
    discount: "30% OFF",
    validTill: "2026-12-31",
    tag: "PREMIUM",
    tagColor: "violet",
    coins: 500,
    minPurchase: "₹2,500",
    category: "Upgrade",
  },
  {
    id: 4,
    title: "New Client Welcome Pack",
    description: "New client organizations get 200 coins credited on their first account setup.",
    code: "WELCOME200",
    discount: "200 Coins",
    validTill: "2026-12-31",
    tag: "NEW",
    tagColor: "indigo",
    coins: 200,
    minPurchase: "Free",
    category: "Welcome",
  },
  {
    id: 5,
    title: "Flash Enterprise Sale",
    description: "Get 75% off on annual bulk hiring licenses. Limited corporate slots available.",
    code: "FLASH75",
    discount: "75% OFF",
    validTill: "2026-12-31",
    tag: "FLASH",
    tagColor: "amber",
    coins: 1000,
    minPurchase: "₹5,000",
    category: "Enterprise",
  },
  {
    id: 6,
    title: "Festival Recruitment Special",
    description: "Special festive markdown of 40% on all job postings plus 100 extra free coins.",
    code: "FESTIVE40",
    discount: "40% OFF",
    validTill: "2026-12-31",
    tag: "FESTIVE",
    tagColor: "pink",
    coins: 100,
    minPurchase: "₹1,500",
    category: "Seasonal",
  },
  {
    id: 7,
    title: "Mega Dhamaka Offer",
    description: "Receive 60% instant flat discount + 1,000 complimentary coins on annual subscription.",
    code: "DIWALI60",
    discount: "60% OFF",
    validTill: "2026-12-31",
    tag: "MEGA",
    tagColor: "rose",
    coins: 1000,
    minPurchase: "₹4,000",
    category: "Seasonal",
  },
  {
    id: 8,
    title: "Annual Starter Package",
    description: "Power up your recruitment pipeline with 45% discount on all custom skill assessments.",
    code: "NEWYEAR45",
    discount: "45% OFF",
    validTill: "2026-12-31",
    tag: "SPECIAL",
    tagColor: "indigo",
    coins: 300,
    minPurchase: "₹2,000",
    category: "Special",
  },
  {
    id: 9,
    title: "Corporate Bulk Hiring",
    description: "Special concession for corporate employers — 35% off plus 500 bonus coins on recharges.",
    code: "CORP35",
    discount: "35% OFF",
    validTill: "2026-12-31",
    tag: "CORPORATE",
    tagColor: "slate",
    coins: 500,
    minPurchase: "₹3,000",
    category: "Enterprise",
  },
];

const CATEGORIES = ["All", "HOT", "BONUS", "PREMIUM", "FLASH", "FESTIVE", "CORPORATE"];


const SpecialOffers = () => {
  const navigate = useNavigate();
  const [copiedOffer, setCopiedOffer] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTag, setSelectedTag] = useState("All");
  const [activeShareModal, setActiveShareModal] = useState(null);

  const copyOfferCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopiedOffer(code);
    toast.success(`Promo code "${code}" copied to clipboard!`);
    setTimeout(() => setCopiedOffer(null), 2500);
  };

  const handleClaimOffer = (offer) => {
    copyOfferCode(offer.code);
    toast.info(`Redirecting to My Wallet to recharge with "${offer.code}"...`);
    setTimeout(() => {
      navigate("/mywallet");
    }, 1200);
  };

  const shareOnWhatsApp = (offer) => {
    const text = `🎉 *Special Offer: ${offer.title}*\n${offer.description}\n\n*Code:* ${offer.code} (${offer.discount})\n*Bonus:* +${offer.coins} Coins\n*Claim here:* ${window.location.origin}/specialoffers`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  const shareOnTelegram = (offer) => {
    const text = `🎉 Special Offer: ${offer.title}\nCode: ${offer.code} - ${offer.discount}\nBonus: +${offer.coins} Coins`;
    const url = `https://t.me/share/url?url=${encodeURIComponent(
      window.location.origin + "/specialoffers"
    )}&text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  const shareByEmail = (offer) => {
    const subject = `Special Deal: ${offer.title} (${offer.discount})`;
    const body = `Hi,\n\nCheck out this special offer on Timely Health Care:\n\n${offer.title}\n${offer.description}\n\nPromo Code: ${offer.code}\nDiscount: ${offer.discount}\nBonus: +${offer.coins} Coins\nValid Till: ${offer.validTill}\n\nClaim your deal at: ${window.location.origin}/specialoffers`;
    const url = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(url, "_blank");
  };

  const shareNative = async (offer) => {
    const shareData = {
      title: offer.title,
      text: `${offer.title} - Use code ${offer.code} to get ${offer.discount}!`,
      url: `${window.location.origin}/specialoffers`,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
        toast.success("Shared successfully!");
      } else {
        copyOfferCode(offer.code);
      }
    } catch (err) {
      // Ignored if cancelled
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const getTagBadgeStyle = (tagColor) => {
    switch (tagColor) {
      case "rose":
        return "bg-rose-50 text-rose-700 border-rose-200";
      case "emerald":
        return "bg-emerald-50 text-emerald-700 border-emerald-200";
      case "violet":
        return "bg-violet-50 text-violet-700 border-violet-200";
      case "indigo":
        return "bg-indigo-50 text-indigo-700 border-indigo-200";
      case "amber":
        return "bg-amber-50 text-amber-700 border-amber-200";
      case "pink":
        return "bg-pink-50 text-pink-700 border-pink-200";
      default:
        return "bg-slate-50 text-slate-700 border-slate-200";
    }
  };

  const filteredOffers = OFFERS_DATA.filter((offer) => {
    const matchesTag =
      selectedTag === "All"
        ? true
        : offer.tag.toUpperCase() === selectedTag.toUpperCase();
    const query = searchQuery.toLowerCase();
    const matchesSearch =
      offer.title.toLowerCase().includes(query) ||
      offer.code.toLowerCase().includes(query) ||
      offer.description.toLowerCase().includes(query) ||
      offer.discount.toLowerCase().includes(query);
    return matchesTag && matchesSearch;
  });

  const totalBonusCoins = OFFERS_DATA.reduce((acc, curr) => acc + curr.coins, 0);

  return (
    <div style={{ backgroundColor: "white" }} className="emp-dash">
      <main>
        {/* Page Header */}
        <div className="emp-dash__header">
          <div>
            <h1 className="emp-dash__greeting">
              Special <span>Offers</span>
            </h1>
            <p className="emp-dash__subtitle">
              Explore limited-time promotional deals, discount promo codes, and coin rewards.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="emp-dash__date-pill">
              <FiTag />
              <span>
                {new Date().toLocaleDateString("en-US", {
                  weekday: "short",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
              </span>
            </div>
            <button
              type="button"
              onClick={() => navigate("/mywallet")}
              className="flex items-center gap-2 py-2.5 px-4 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-bold uppercase tracking-wider transition-all shadow-lg shadow-indigo-600/20 cursor-pointer"
            >
              <FiZap size={14} /> Recharge Wallet
            </button>
          </div>
        </div>

        {/* Stats Row */}
        <div className="emp-dash__stats grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="emp-dash__stat">
            <div className="emp-dash__stat-top">
              <span className="emp-dash__stat-label">Active Promotions</span>
              <div className="emp-dash__stat-icon emp-dash__stat-icon--indigo">
                <FiTag />
              </div>
            </div>
            <div className="emp-dash__stat-value">{OFFERS_DATA.length}</div>
            <div className="emp-dash__stat-meta">verified live promo codes</div>
          </div>

          <div className="emp-dash__stat">
            <div className="emp-dash__stat-top">
              <span className="emp-dash__stat-label">Max Discount</span>
              <div className="emp-dash__stat-icon emp-dash__stat-icon--violet">
                <FiPercent />
              </div>
            </div>
            <div className="emp-dash__stat-value text-violet-700">75% OFF</div>
            <div className="emp-dash__stat-meta">on enterprise packages</div>
          </div>

          <div className="emp-dash__stat">
            <div className="emp-dash__stat-top">
              <span className="emp-dash__stat-label">Total Bonus Coins</span>
              <div className="emp-dash__stat-icon emp-dash__stat-icon--emerald">
                <FiGift />
              </div>
            </div>
            <div className="emp-dash__stat-value text-emerald-700">
              +{totalBonusCoins.toLocaleString()}
            </div>
            <div className="emp-dash__stat-meta">available reward pool</div>
          </div>

          <div className="emp-dash__stat">
            <div className="emp-dash__stat-top">
              <span className="emp-dash__stat-label">Security & Guarantee</span>
              <div className="emp-dash__stat-icon emp-dash__stat-icon--rose">
                <FiShield />
              </div>
            </div>
            <div className="emp-dash__stat-value text-rose-700">100%</div>
            <div className="emp-dash__stat-meta">instant checkout validation</div>
          </div>
        </div>

        {/* Table Directory Card */}
        <div className="emp-dash__card p-6 mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-5">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-indigo-50 flex items-center justify-center">
                <FiTag size={15} className="text-indigo-600" />
              </div>
              <div>
                <h2 className="text-sm font-bold text-gray-800 uppercase tracking-widest">
                  Offers & Promotions Directory
                </h2>
                <p className="text-[10px] text-gray-500">
                  Showing {filteredOffers.length} of {OFFERS_DATA.length} active deals
                </p>
              </div>
            </div>

            {/* Category Filter Pills */}
            <div className="flex flex-wrap items-center gap-1.5 bg-gray-50 p-1 rounded-xl border border-gray-200">
              {CATEGORIES.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => setSelectedTag(tag)}
                  className={`px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-wider transition-all cursor-pointer ${
                    selectedTag === tag
                      ? "bg-indigo-600 text-white shadow-sm"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-200/60"
                  }`}
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>

          {/* Search Bar */}
          <div className="relative mb-5">
            <FiSearch
              className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors z-10"
              size={14}
            />
            <input
              type="text"
              placeholder="Search offers by name, discount, promo code, or description..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-11 pr-4 py-2.5 bg-gray-50/50 rounded-xl border border-gray-200 focus:bg-white focus:ring-4 focus:ring-indigo-600/5 focus:border-indigo-600 transition-all outline-none text-xs text-gray-800"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <FiX size={14} />
              </button>
            )}
          </div>

          {/* Table */}
          <div className="overflow-x-auto rounded-xl border border-gray-200/80">
            <table className="w-full text-left text-xs border-collapse">
              <thead>
                <tr className="bg-gray-50/90 border-b border-gray-200 text-gray-600 uppercase text-[10px] tracking-wider font-bold">
                  <th className="py-3.5 px-4 w-12 text-center">#</th>
                  <th className="py-3.5 px-4 min-w-[220px]">Offer Title & Details</th>
                  <th className="py-3.5 px-4 min-w-[140px]">Promo Code</th>
                  <th className="py-3.5 px-4 min-w-[150px]">Discount & Bonus</th>
                  <th className="py-3.5 px-4 text-center min-w-[100px]">Tag</th>
                  <th className="py-3.5 px-4 min-w-[120px]">Valid Until</th>
                  <th className="py-3.5 px-4 text-center min-w-[160px]">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredOffers.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="py-12 text-center">
                      <div className="flex flex-col items-center justify-center">
                        <div className="w-12 h-12 rounded-xl bg-gray-50 text-gray-300 flex items-center justify-center mb-2">
                          <FiTag size={24} />
                        </div>
                        <p className="text-xs font-bold text-gray-700 uppercase tracking-wider">
                          No Offers Found
                        </p>
                        <p className="text-[10px] text-gray-400 mt-1">
                          Try searching for different keywords or resetting filters.
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredOffers.map((offer, index) => {
                    const isCopied = copiedOffer === offer.code;
                    return (
                      <tr
                        key={offer.id}
                        className="hover:bg-indigo-50/20 transition-colors group"
                      >
                        {/* Index */}
                        <td className="py-3.5 px-4 text-center text-gray-400 font-medium text-[11px]">
                          {index + 1}
                        </td>

                        {/* Title & Description */}
                        <td className="py-3.5 px-4">
                          <div className="flex items-start gap-3">
                            <div className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm">
                              <FiGift size={15} />
                            </div>
                            <div className="min-w-0">
                              <div className="flex items-center gap-2">
                                <p className="font-bold text-gray-900 text-xs truncate">
                                  {offer.title}
                                </p>
                              </div>
                              <p className="text-[11px] text-gray-500 line-clamp-1 mt-0.5">
                                {offer.description}
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* Code Block */}
                        <td className="py-3.5 px-4">
                          <div className="inline-flex items-center gap-1.5 bg-gray-50 border border-gray-200/90 px-2.5 py-1 rounded-lg">
                            <span className="font-mono font-bold text-gray-900 text-xs tracking-wider">
                              {offer.code}
                            </span>
                            <button
                              type="button"
                              onClick={() => copyOfferCode(offer.code)}
                              className="text-gray-400 hover:text-indigo-600 transition-colors p-0.5 cursor-pointer"
                              title="Copy Code"
                            >
                              {isCopied ? (
                                <FiCheck size={13} className="text-emerald-600" />
                              ) : (
                                <FiCopy size={13} />
                              )}
                            </button>
                          </div>
                        </td>

                        {/* Discount & Bonus */}
                        <td className="py-3.5 px-4">
                          <div className="flex flex-col gap-1">
                            <span className="inline-flex items-center gap-1 text-xs font-black text-indigo-700">
                              {offer.discount}
                            </span>
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-100 w-fit">
                              <FiGift size={10} /> +{offer.coins} Bonus Coins
                            </span>
                          </div>
                        </td>

                        {/* Tag Badge */}
                        <td className="py-3.5 px-4 text-center">
                          <span
                            className={`inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wider border ${getTagBadgeStyle(
                              offer.tagColor
                            )}`}
                          >
                            {offer.tag}
                          </span>
                        </td>

                        {/* Valid Until */}
                        <td className="py-3.5 px-4 text-gray-600 text-[11px]">
                          <div className="flex items-center gap-1.5 font-medium">
                            <FiClock size={11} className="text-gray-400" />
                            <span>{formatDate(offer.validTill)}</span>
                          </div>
                          <span className="text-[9px] font-bold text-emerald-600 uppercase tracking-wider block mt-0.5">
                            Active
                          </span>
                        </td>

                        {/* Actions */}
                        <td className="py-3.5 px-4 text-center">
                          <div className="flex items-center justify-center gap-2">
                            <button
                              type="button"
                              onClick={() => handleClaimOffer(offer)}
                              className="px-3 py-1.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-[11px] font-bold uppercase tracking-wider transition-all shadow-sm shadow-indigo-600/20 flex items-center gap-1 cursor-pointer"
                            >
                              Claim <FiArrowRight size={11} />
                            </button>

                            <button
                              type="button"
                              onClick={() => setActiveShareModal(offer)}
                              className="p-2 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-600 transition-colors border border-gray-200 cursor-pointer"
                              title="Share Offer"
                            >
                              <FiShare2 size={13} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Quick Tip Card matching PostNewJob */}
        <div className="p-4 bg-amber-50 rounded-2xl border border-amber-100 flex items-start gap-3 mb-6">
          <FiZap size={16} className="text-amber-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-xs font-bold text-amber-900 uppercase tracking-wider mb-1">
              How to Apply Promo Codes
            </h4>
            <p className="text-[11px] text-amber-800 leading-relaxed">
              Click <strong>"Claim"</strong> or copy any promo code above, then proceed to the{" "}
              <a href="/mywallet" className="font-bold underline text-indigo-600">
                My Wallet
              </a>{" "}
              page to apply your discount during coin recharge or job posting checkouts.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-center gap-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest py-8">
          <FiClipboard className="text-indigo-500" />
          Last Updated: {new Date().toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
        </div>
      </main>

      {/* Share Modal */}
      {activeShareModal && (
        <div className="fixed inset-0 z-[300] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 border border-gray-100 animate-in fade-in zoom-in-95 duration-200 space-y-5">
            <div className="flex items-center justify-between border-b border-gray-100 pb-3">
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center">
                  <FiShare2 size={16} />
                </div>
                <h3 className="text-sm font-bold text-gray-900">Share Special Offer</h3>
              </div>
              <button
                type="button"
                onClick={() => setActiveShareModal(null)}
                className="w-7 h-7 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-colors cursor-pointer"
              >
                <FiX size={15} />
              </button>
            </div>

            <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
              <p className="text-xs font-bold text-gray-900">{activeShareModal.title}</p>
              <p className="text-[11px] text-gray-600 mt-0.5">{activeShareModal.description}</p>
              <div className="mt-2 flex items-center gap-2">
                <span className="font-mono font-bold text-indigo-600 text-xs px-2 py-0.5 bg-indigo-50 rounded border border-indigo-100">
                  {activeShareModal.code}
                </span>
                <span className="text-[11px] font-extrabold text-emerald-700">
                  {activeShareModal.discount}
                </span>
              </div>
            </div>

            {/* Share Buttons Grid */}
            <div className="grid grid-cols-4 gap-2.5">
              <button
                type="button"
                onClick={() => {
                  shareOnWhatsApp(activeShareModal);
                  setActiveShareModal(null);
                }}
                className="flex flex-col items-center justify-center p-3 rounded-xl border border-emerald-100 bg-emerald-50/40 hover:bg-emerald-50 transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 rounded-xl bg-emerald-600 text-white flex items-center justify-center text-lg mb-1.5 shadow-sm shadow-emerald-600/20">
                  <FaWhatsapp />
                </div>
                <span className="text-[10px] font-bold text-gray-700">WhatsApp</span>
              </button>

              <button
                type="button"
                onClick={() => {
                  shareOnTelegram(activeShareModal);
                  setActiveShareModal(null);
                }}
                className="flex flex-col items-center justify-center p-3 rounded-xl border border-sky-100 bg-sky-50/40 hover:bg-sky-50 transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 rounded-xl bg-sky-500 text-white flex items-center justify-center text-lg mb-1.5 shadow-sm shadow-sky-500/20">
                  <FaTelegramPlane />
                </div>
                <span className="text-[10px] font-bold text-gray-700">Telegram</span>
              </button>

              <button
                type="button"
                onClick={() => {
                  shareByEmail(activeShareModal);
                  setActiveShareModal(null);
                }}
                className="flex flex-col items-center justify-center p-3 rounded-xl border border-indigo-100 bg-indigo-50/40 hover:bg-indigo-50 transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 rounded-xl bg-indigo-600 text-white flex items-center justify-center text-lg mb-1.5 shadow-sm shadow-indigo-600/20">
                  <FiMail />
                </div>
                <span className="text-[10px] font-bold text-gray-700">Email</span>
              </button>

              <button
                type="button"
                onClick={() => {
                  shareNative(activeShareModal);
                  setActiveShareModal(null);
                }}
                className="flex flex-col items-center justify-center p-3 rounded-xl border border-gray-200 bg-gray-50/70 hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 rounded-xl bg-gray-800 text-white flex items-center justify-center text-lg mb-1.5 shadow-sm">
                  <FiShare2 />
                </div>
                <span className="text-[10px] font-bold text-gray-700">More</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpecialOffers;